import { ButtonGroup, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, ThumbDown, ThumbDownAlt, ThumbUp } from "@material-ui/icons";
import { DownloadButton, useAuth, useAccessControl } from "@airborne/react-admin";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import {
  Button,
  Create,
  Datagrid,
  FunctionField,
  ListContextProvider,
  required,
  SelectArrayInput,
  SelectInput,
  TextField,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import RequestStatusField from "../../../../../src/Components/ReferenceFields/RequestStatus/RequestStatusField";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { Separator } from "../../../../../src/Components/Separator";
import { UploadFile } from "../../../../../src/Components/UploadFile";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { AlternatePnType } from "../../../../Enums/AlternatePnType";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { ModelState } from "../../Models/ModelStateEnum";
import { RequestAlternatePnPostModel, RequestAlternatePnPutModel } from "../../Models/RequestAlternatePn";
import { SourceRequestOrder } from "../Constant/Source";
import AlternatePnStatusChip from "../Statu/AlternatePnStatusChip";
import RequestRejectedRemark from "./RequestRejectedRemark";

const AlternatePnCreate = props => {
  const { canCreate, canDelete, canEdit, canRead, hasAccess } = useAccessControl("customers");

  const useStyles = makeStyles({
    toolbar: {
      flex: "auto",
      justifyContent: "center",
      backgroundColor: "white",
    },
    defaultToolbar: {
      flex: "auto",
      justifyContent: "center",
    },
  });

  const [alternatePnList, setAlternatePnList] = useState([] as any);
  const provider = useDataProvider();
  const [isAlternatePnListReceived, setisAlternatePnListReceived] = useState(false);
  const [pnType, setPnType] = useState(AlternatePnType.AlternatePn);
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();

  const requestId = props.requestId;

  const getAlternatePnList = async () => {
    const { data } = await provider.getList("invpngs/getcustomlist", {
      pagination: {
        page: 1,
        perPage: 5 + (props?.requestAlternatePn?.length ?? 0),
      },
      sort: { field: "id", order: "DESC" },
      filter: {
        pn__eq: props.requestDetail.customerRequestComponent,
      },
    });
    if (data.length > 0) {
      const requestAlternatePns = props?.requestAlternatePn?.map?.(x => x.altPn) || [];
      let mappedData = data
        ?.map?.(item => ({
          id: item.pn,
          pn: item.pn,
        }))
        ?.filter?.(pn => !requestAlternatePns?.includes?.(pn.pn));
      setAlternatePnList(mappedData);
    }
  };

  const pnTypeOnChange = e => {
    let pnType = e.target.value;
    setPnType(pnType);
    if (isAlternatePnListReceived === false) {
      if (pnType === AlternatePnType.AlternatePn) {
        getAlternatePnList();
        setisAlternatePnListReceived(true);
      }
    }
  };
  const CreateAlternateButtonClick = async e => {
    await CreateAlternatePn(e).then(() => {
      history.push("/requestorders/" + requestId + "/" + Number(RequestOrderTabEnum.AlternatePnTab));
    });
  };

  const GetPostNotifyTitle = () => {
    if (pnType === AlternatePnType.AlternatePn) {
      return `Alternate PN offered`;
    }

    return `Replacement PN offered`;
  };

  const CreateAlternatePn = async e => {
    // RBH- PBH Logic eklenecek.!

    setLoading(true);
    if (e?.pnType === AlternatePnType.AlternatePn) {
      var requestAlternatePnsModel = e?.altPn?.map?.(element => ({
        RequestId: requestId,
        AltPn: element,
        Status: RequestStatus.AlternatePnOffered,
      }));

      dataProvider
        .postBulkRequestAlternatePn(requestAlternatePnsModel)
        .then(result => {
          props.finalCallBack();
          notify(GetPostNotifyTitle(), "success", false, true);
        })
        .catch(result => {
          notify(`${result}`, "error", false, true);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      let requestAlternatePnCreateModel: RequestAlternatePnPostModel = new RequestAlternatePnPostModel();

      requestAlternatePnCreateModel.RequestId = requestId;
      requestAlternatePnCreateModel.AltPn = e.altPn;
      requestAlternatePnCreateModel.AltSn = e.altSn;
      requestAlternatePnCreateModel.Status = RequestStatus.ReplacementPnOffered;
      dataProvider
        .postRequestAlternatePn(requestAlternatePnCreateModel)
        .then(result => {
          props.finalCallBack();
          notify(GetPostNotifyTitle(), "success", false, true);
        })
        .catch(result => {
          notify(`${result}`, "error", false, true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const onClickAlternate = (handleSubmit) => (e) => {
  //   handleSubmit()?.then(() => {
  //     history.push('/requestorders/' + requestId + '/'  + Number(RequestOrderTabEnum.AlternatePnTab))
  //   })
  // }

  const GetSectionTitle = () => {
    if (pnType === AlternatePnType.AlternatePn) {
      return "Alternate Pn Info";
    }

    return "Replacement Pn Info";
  };

  const GetButtonTitle = () => {
    if (pnType === AlternatePnType.AlternatePn) {
      if (loading) {
        return "Alternate PN is being offered!";
      }

      return "Offer Alternate PN";
    }

    return loading ? "Replacement PN is being offered!" : "Offer Replacement PN";
  };

  return (
    <Form
      onSubmit={CreateAlternateButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Grid container direction="row" item xs={12} spacing={1} justifyContent="center" alignItems="center">
                    <SectionTitle label={GetSectionTitle()} />
                  </Grid>
                  <Separator />

                  <Grid
                    container
                    direction="row"
                    xs={12}
                    spacing={1}
                    item
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      padding: "10px",
                    }}
                  >
                    <Grid item xs={12} sm={4}>
                      <SelectInput
                        source="pnType"
                        choices={[
                          {
                            id: AlternatePnType.AlternatePn,
                            label: "Alternate Pn",
                          },
                          {
                            id: AlternatePnType.ReplacementPn,
                            label: "Replacement Pn",
                          },
                        ]}
                        onChange={pnTypeOnChange}
                        optionText="label"
                        optionValue="id"
                        validate={required()}
                        fullWidth
                      />
                    </Grid>
                    {values?.pnType === AlternatePnType.AlternatePn && (
                      <Grid item xs={12} sm={8}>
                        <SelectArrayInput
                          source="altPn"
                          choices={alternatePnList}
                          optionText="pn"
                          optionValue="id"
                          validate={required()}
                          fullWidth
                        />
                      </Grid>
                    )}
                    {values?.pnType === AlternatePnType.ReplacementPn && (
                      <>
                        <Grid item xs={12} sm={4}>
                          <TextInput
                            source="altPn"
                            label="Replacement PN"
                            fullWidth
                            validate={required()}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextInput
                            source="altSn"
                            label="Alternate SN"
                            variant="outlined"
                            validate={required()}
                            fullWidth
                          />
                        </Grid>
                      </>
                    )}
                    <Separator />
                    <Toolbar {...props}>
                      <Button
                        label={GetButtonTitle()}
                        disabled={loading || values?.pnType == null}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                    </Toolbar>
                  </Grid>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

const AlternatePnView = props => {
  const [loading, setLoading] = useState(false);
  const [remarkDialog, setRemarkDialog] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();
  const [altPn] = useState(props.requestAlternatePn);
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const requestId = props.requestId;

  const isRejectButtonShown = status => {
    if (status === RequestStatus.ReplacementPnOffered || status === RequestStatus.AlternatePnOffered) {
      return false;
    }
    return true;
  };

  const AcceptButtonClick = props => e => {
    let requestAlternatePutModel: RequestAlternatePnPutModel = new RequestAlternatePnPutModel();
    requestAlternatePutModel.id = props.record.id;
    requestAlternatePutModel.AltPn = props.record.altPn;
    requestAlternatePutModel.AltSn = props.record.altSn;
    requestAlternatePutModel.RequestId = props.record.requestId;
    requestAlternatePutModel.Status =
      props.record.altSn != null ? RequestStatus.ReplacementPnAccepted : RequestStatus.AlternatePnAccepted;
    requestAlternatePutModel.UpdatedBy = user?.employeeId;
    requestAlternatePutModel.UpdatedDate = new Date();

    updateRequestOrder(requestAlternatePutModel);
  };
  const RejectReplacementClick = (record, remark) => {
    let requestAlternatePutModel: RequestAlternatePnPutModel = new RequestAlternatePnPutModel();
    setRemarkDialog(false);
    requestAlternatePutModel.id = record.id;
    requestAlternatePutModel.AltPn = record.altPn;
    requestAlternatePutModel.Remark = remark;
    requestAlternatePutModel.AltSn = record.altSn;
    requestAlternatePutModel.RequestId = record.requestId;
    requestAlternatePutModel.Status = RequestStatus.ReplacementPnRejected;
    requestAlternatePutModel.UpdatedBy = user?.employeeId;
    requestAlternatePutModel.UpdatedDate = new Date();

    updateRequestOrder(requestAlternatePutModel);
  };
  const RejectAllButtonClick = props => e => {
    let requestAlternatePutModel: RequestAlternatePnPutModel = new RequestAlternatePnPutModel();
    requestAlternatePutModel.id = props.requestAlternatePn?.[0]?.id;
    requestAlternatePutModel.AltPn = props.requestAlternatePn?.[0]?.altPn;
    requestAlternatePutModel.AltSn = props.requestAlternatePn?.[0]?.altSn;
    requestAlternatePutModel.RequestId = props.requestAlternatePn?.[0]?.requestId;
    requestAlternatePutModel.Status =
      props.requestAlternatePn?.[0]?.altSn != null
        ? RequestStatus.ReplacementPnRejected
        : RequestStatus.AlternatePnRejected;
    requestAlternatePutModel.UpdatedBy = user?.employeeId;
    requestAlternatePutModel.UpdatedDate = new Date();
    dataProvider
      .postRejectAllRequestAlternatePn(requestAlternatePutModel)
      .then(result => {
        props.finalCallBack();
        notify(`Record Updated`, "success", false, true);
        history.push("/requestorders/" + requestId + "/3");
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const sendToStatus19 = e => {
    let requestAlternatePutModel: RequestAlternatePnPutModel = new RequestAlternatePnPutModel();
    requestAlternatePutModel.id = 0;
    requestAlternatePutModel.AltPn = "";
    requestAlternatePutModel.AltSn = "";
    requestAlternatePutModel.RequestId = props.requestId;
    requestAlternatePutModel.Status = RequestStatus.Status19;
    requestAlternatePutModel.UpdatedBy = user?.employeeId;
    requestAlternatePutModel.UpdatedDate = new Date();
    updateRequestOrder(requestAlternatePutModel);
  };
  const updateRequestOrder = model => {
    dataProvider
      .putRequestAlternatePn(model)
      .then(result => {
        props.finalCallBack();
        notify(`Record Updated`, "success", false, true);
        history.push("/requestorders/" + requestId + "/3");
      })
      .catch(error => notify(`${error}`, "error", false, true))
      .finally(() => setLoading(false));
  };
  const offerAnotherPn = e => {
    props?.offerAnotherPnClick?.(true);
  };
  const UploadFileAction = props => {
    return (
      <UploadFile
        label=""
        multiple={false}
        placeholder={"Upload"}
        onHandleFileExecute={() => console.log("file uploaded successfully")}
        source="alternatepnfilerelations"
        object={{
          alternatePnId: props?.record?.id,
        }}
      />
    );
  };
  const AlternatePnAcceptButton = props => {
    return props.record.status === RequestStatus.ReplacementPnOffered ? (
      <ButtonGroup variant="text" size="small">
        <Button
          size="small"
          variant="contained"
          style={{ backgroundColor: "green" }}
          onClick={AcceptButtonClick(props)}
        >
          {loading ? <CircularProgress size="1rem" color="secondary" /> : <ThumbUp />}
        </Button>
        <RequestRejectedRemark open={remarkDialog} record={props.record} handleSubmit={RejectReplacementClick} />
        {!props.alternatePns.find(x => x.status === RequestStatus.ReplacementPnAccepted) && (
          <Button
            size="small"
            variant="contained"
            style={{ backgroundColor: "red" }}
            onClick={() => setRemarkDialog(true)}
          >
            {loading ? <CircularProgress size="1rem" color="secondary" /> : <ThumbDown />}
          </Button>
        )}
      </ButtonGroup>
    ) : props.record.status === RequestStatus.AlternatePnOffered ? (
      <Button size="small" variant="contained" style={{ backgroundColor: "green" }} onClick={AcceptButtonClick(props)}>
        {loading ? <CircularProgress size="1rem" color="secondary" /> : <ThumbUp />}
      </Button>
    ) : (
      <Button size="small" variant="contained" onClick={AcceptButtonClick(props)} disabled>
        {props.record.status === RequestStatus.ReplacementPnAccepted ||
        props.record.status === RequestStatus.AlternatePnAccepted ? (
          <ThumbUp />
        ) : (
          <ThumbDown />
        )}
      </Button>
    );
  };

  const onClickAlternate = handleSubmit => e => {
    handleSubmit()?.then(() => {
      history.push("/requestorders/" + requestId + "/3");
    });
  };
  const CreateAlternateButtonClick = async e => {
    await CreateAlternatePn(e).then(() => {
      history.push("/requestorders/" + requestId + "/3");
    });
  };

  const CreateAlternatePn = async e => {
    setLoading(true);

    let requestAlternatePnCreateModel: RequestAlternatePnPostModel = new RequestAlternatePnPostModel();

    requestAlternatePnCreateModel.RequestId = requestId;
    requestAlternatePnCreateModel.AltPn = e.altPn;
    requestAlternatePnCreateModel.AltSn = e.altSn;
    requestAlternatePnCreateModel.Status = RequestStatus.ReplacementPnOffered;
    dataProvider.postRequestAlternatePn(requestAlternatePnCreateModel).then(result => {
      props.createFinalCallBack();
      notify(`Alternate PN offered`, "success", false, true);
      setLoading(false);
    });
  };
  return (
    <>
      <Grid container direction="row" spacing={1} justify="space-around" alignItems="center">
        <SectionTitle label="Alternate Pn Info" />
        <AlternatePnStatusChip requestAlternatePn={altPn} />
      </Grid>
      <Separator />
      {user?.isCustomer === false &&
        [
          RequestStatus.ReplacementPnOffered,
          RequestStatus.ReplacementPnRejected,
          RequestStatus.AlternatePnAccepted,
          RequestStatus.AlternatePnOffered,
          RequestStatus.AlternatePnRejected,
        ].includes(props.requestDetail?.requestStatus) && (
          <Grid container direction="row" spacing={1} justify="space-around" alignItems="center">
            <Form
              onSubmit={CreateAlternateButtonClick}
              render={({ handleSubmit, form, values }) => (
                <form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Create {...props}>
                        <>
                          <Grid
                            container
                            direction="row"
                            xs={12}
                            spacing={1}
                            item
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              padding: "10px",
                            }}
                          >
                            <Grid item xs={12} sm={4}>
                              <TextInput
                                source="altPn"
                                label="Alternate PN"
                                fullWidth
                                validate={required()}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextInput
                                source="altSn"
                                label="Alternate SN"
                                variant="outlined"
                                validate={required()}
                                fullWidth
                              />
                            </Grid>
                            <Separator />
                            {canEditOnlyShow && (
                              <Button
                                label={loading ? "Replacement PN is being offered!" : "Offer Replacement PN"}
                                disabled={loading}
                                size="medium"
                                variant="contained"
                                color="primary"
                                onClick={onClickAlternate(handleSubmit)}
                              >
                                {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                              </Button>
                            )}
                          </Grid>
                        </>
                      </Create>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        )}
      <Separator />
      <Grid container style={{ width: "100%", overflow: "auto", marginBottom: 5 }}>
        <Grid item xs={12} sm={12}>
          <ListContextProvider
            value={{
              data: keyBy(props.requestAlternatePn, "id"),
              ids: props.requestAlternatePn?.map?.(({ id }) => id),
              currentSort: { field: "id", order: "ASC" },
            }}
          >
            <Datagrid>
              {user?.isCustomer && (
                <AlternatePnAcceptButton
                  label="Actions"
                  orderData={props.requestDetail}
                  alternatePns={props.requestAlternatePn}
                  finalCallBack={props.finalCallBack}
                />
              )}
              {user?.isCustomer === false && <UploadFileAction label="Actions" />}
              <FunctionField
                style={{ fontSize: 12 }}
                label="Files"
                render={(record: any) => {
                  return record?.files?.map?.(file => (
                    <DownloadButton target={`download/${file.objectKey}`} buttonText={file.name} variant="text" />
                  ));
                }}
              />

              <TextField label="Alternative PNs" source="altPn" />
              <TextField label="Alternative SN" source="altSn" />

              <TextField label="Status Code" source="status" />
              <TextField label="Customer Remark" source="remark" />
              <RequestStatusField label="Status" source="status" />
              <CreatedByField label="OFFERED BY" link={false} />
              <CustomDateField source="createdDate" locales="en-GB" label="OFFERED  DATE" showTime />
              <CreatedByField source="updatedBy" label="APPROVED/REJECTED BY" link={false} />
              <CustomDateField source="updatedDate" label="APPROVED/REJECTED DATE" locales="en-GB" showTime />
            </Datagrid>
          </ListContextProvider>
        </Grid>
      </Grid>
      <Grid style={{ display: "flex", justifyContent: "end" }}>
        {props.requestDetail?.requestStatus === RequestStatus.AlternatePnOffered &&
          user?.isCustomer &&
          canEditOnlyShow && (
            <Button
              label={loading ? "Rejected!" : "Reject All Alternate Pn"}
              disabled={isRejectButtonShown(props.requestDetail?.requestStatus)}
              size="medium"
              variant="contained"
              color="primary"
              onClick={RejectAllButtonClick(props)}
              style={{ margin: "8px" }}
            >
              {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
            </Button>
          )}
        {(props.requestDetail?.requestStatus === RequestStatus.ReplacementPnRejected ||
          props.requestDetail?.requestStatus === RequestStatus.AlternatePnRejected) &&
          user?.isCustomer === false &&
          canEditOnlyShow && (
            <>
              <Button
                label={"Offer another pn"}
                size="medium"
                variant="contained"
                onClick={offerAnotherPn}
                style={{ margin: "8px", background: "#ffc107" }}
              >
                {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
              </Button>
              <Button
                label={"Send to status 19"}
                size="medium"
                variant="contained"
                color="primary"
                onClick={sendToStatus19}
                style={{ margin: "8px" }}
              >
                {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
              </Button>
            </>
          )}
      </Grid>
    </>
  );
};

const RequestAlternatePn = props => {
  const [isOfferAnotherPn, setIsOfferAnotherPn] = React.useState(false);
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType = props?.requestAlternatePn === null ? ModelState.Create : ModelState.View;
    setTabType(tempTabType);
  }, [props?.requestAlternatePn]);
  const finalCallBack = e => {
    setIsOfferAnotherPn(false);
    props.parentCallBack();
  };
  return isOfferAnotherPn || tabType === ModelState.Create ? (
    <AlternatePnCreate
      resource="/requestalternatepns"
      basePath=""
      requestId={props.requestId}
      requestAlternatePn={props.requestAlternatePn}
      requestDetail={props.requestDetailData}
      finalCallBack={finalCallBack}
    />
  ) : (
    <AlternatePnView
      resource="/requestalternatepns"
      basePath=""
      requestId={props.requestId}
      requestAlternatePn={props.requestAlternatePn}
      requestDetail={props.requestDetailData}
      finalCallBack={e => props.parentCallBack()}
      offerAnotherPnClick={setIsOfferAnotherPn}
      createFinalCallBack={finalCallBack}
    />
  );
};

export default RequestAlternatePn;
